/* Petite Studio accessibility helpers (Oct 2026). No visual effect.
 * 1) Third-party tracking pixels (PostPilot) inject <img> tags with no alt attribute -> mark them decorative.
 * 2) Flickity carousels hide off-screen slides with aria-hidden="true" but leave their links/buttons in the
 *    keyboard Tab order -> take them out while hidden, restore when the slide is visible again.
 */
(function () {
  'use strict';

  /* ---- 1. tracking pixels ---- */
  function fixPixels(root) {
    (root || document).querySelectorAll('img[src*="trkn.us"], img[id^="_pxPixel"]').forEach(function (img) {
      if (!img.hasAttribute('alt')) {
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      }
    });
  }
  fixPixels();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG') fixPixels(n.parentNode); else fixPixels(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---- 2. carousel focus management ---- */
  var FOCUSABLE = 'a[href], button, input, select, textarea, iframe, [tabindex]';
  function hide(el) {
    if (el.getAttribute('tabindex') === '-1') return;
    el.setAttribute('data-ps-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
    el.setAttribute('tabindex', '-1');
  }
  function restore(el) {
    if (!el.hasAttribute('data-ps-tabindex')) return;
    var prev = el.getAttribute('data-ps-tabindex');
    if (prev === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', prev);
    el.removeAttribute('data-ps-tabindex');
  }
  function syncCarousel(gallery) {
    gallery.querySelectorAll('.flickity-slider > *').forEach(function (cell) {
      var hidden = cell.getAttribute('aria-hidden') === 'true';
      if (cell.matches(FOCUSABLE)) { if (hidden) hide(cell); else restore(cell); }
      cell.querySelectorAll(FOCUSABLE).forEach(function (el) { if (hidden) hide(el); else restore(el); });
    });
  }
  function hook(gallery) {
    if (gallery.__psA11y) return;
    gallery.__psA11y = true;
    syncCarousel(gallery);
    var f = window.Flickity && window.Flickity.data ? window.Flickity.data(gallery) : null;
    if (f) {
      f.on('select', function () { syncCarousel(gallery); });
      f.on('settle', function () { syncCarousel(gallery); });
    }
  }
  var pending = null;
  function scan() {
    pending = null;
    document.querySelectorAll('.flickity-enabled').forEach(hook);
  }
  function scheduleScan() { if (!pending) pending = setTimeout(scan, 100); }
  if (document.readyState === 'complete') scan(); else window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scheduleScan);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t.classList && t.classList.contains('flickity-enabled') && !t.__psA11y) { scheduleScan(); return; }
    }
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });

  /* ---- 3. header cart: link wrapping a button ---- */
  /* The announcement-bar cart icon is a <button> (opens the drawer) nested inside an <a href="/cart">
   * kept as a no-JavaScript fallback. With JavaScript on, the button handles the click and the link never
   * navigates, so the link is a redundant, mostly covered tap target. Drop the href while JS is running;
   * the no-JS fallback is untouched because this script never runs without JS. */
  document.querySelectorAll('.slideout__trigger--open > a[href] > .js-mini-cart-trigger').forEach(function (btn) {
    btn.parentElement.removeAttribute('href');
  });
})();
